<template>
  <div :class="classes">
    <div class="vi-help--item__title">
      <b>常见问题</b>
    </div>
    <div class="vi-help-problem--box">
      <div class="vi-help-problem--box__item" v-for="(el,$index) in data" :key="$index" @click="onToPath()" v-if="el.status === 1">
        <a href="javascript:">{{tru(el.questionTitle,13)}}</a>
      </div>
    </div>
    <div class="vi-help--item__more" @click="onToPath()">
      <a href="javascript:">了解更多</a>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  const prefixCls = 'vi-help-problem'
  export default {
    name: 'vi-help-problem',
    data () {
      return {}
    },
    props: {
      data: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      tru (key, length) {
        return _.truncate(key, { 'length': length, 'omission': '...' })
      },
      onToPath () {
        window.open(`${global.helpToDomain}problem/${this.helpParams.reId}`)
      }
    },
    watch: {},
    beforeCreate () {
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    },
    computed: {
      ...mapState('common', ['helpParams']),
      classes () {
        return [
          `${prefixCls}`
        ]
      }
    },
    components: {}
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  $-prefix-cls: "vi-help-problem";
  .#{$-prefix-cls} {
    &--box {
      &__item {
        line-height: 24px;
        a,a:hover {
          transition: all 0.2s ease-out;
        }
        a {
          font-size: 14px;
          color: #5D5D5D;
          text-decoration: none;
          &:hover {
            color: #2d8cf0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/helpProblem.vue